<template>
  <div class="message">
    <div class="messagebox">
      <el-badge :value="num" :hidden="!num" :max="99" class="badge">
        <i class="el-icon-bell" @click="click"></i>
      </el-badge>
    </div>
  </div>
</template>

<script>
export default {
  name: "Message",
  data() {
    return {
      timer: null,
      num: 0,
    };
  },
  mounted() {
    this.init();
  },
  beforeDestroy() {
    this.destroy();
  },
  methods: {
    click() {
      this.$router.push("/other/message");
    },
    init() {
      this.getmessage();
      // this.timer = setInterval(() => {
      //   this.getmessage();
      // }, 3000);
    },
    async getmessage() {
      if (!this.$store.state.user.token) return;
      let res = await this.post("member.messagelist", {});
      if (!res) return;
      this.num = res.data.filter((item) => !item.isread).length;
      this.$store.dispatch("user/updateMessages", res.data);
    },
    destroy() {
      if (this.timer) clearInterval(this.timer), (this.timer = null);
    },
  },
};
</script>

<style scoped lang="postcss">
.message {
  margin-right: 10px;
  line-height: 50px;
  .messagebox {
    height: 20px;
    display: inline-block;
    position: relative;
    line-height: 20px;
  }
}
</style>
